// extracted by mini-css-extract-plugin
export default {"container":"send-email-button_container__P8Wws","disabled":"send-email-button_disabled__EsxJ6"};